/* eslint-disable react/prop-types */
import React from 'react';
import { Label } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import ReactSelect from 'react-select';

const PeriodFilter = ({ t, selectedDays, onChange }) => {
  const options = [
    { label: t('revenue-dashboard.period.30days'), value: 30 },
    { label: t('revenue-dashboard.period.60days'), value: 60 },
    { label: t('revenue-dashboard.period.90days'), value: 90 },
  ];

  const selectedOption = options.find((opt) => opt.value === selectedDays);

  return (
    <div className="filter-item filter-item-no-border d-flex justify-content-end mb-4">
      <div style={{ minWidth: '180px' }}>
        <Label className="form-label text-muted text-uppercase fw-semibold mb-1">
          {t('revenue-dashboard.period.label')}
        </Label>
        <ReactSelect
          isSearchable={false}
          name="windowSizeDays"
          value={selectedOption}
          options={options}
          onChange={(v) => onChange(v.value)}
          styles={{
            control: (base) => ({
              ...base,
              minHeight: '38px',
              borderColor: '#ced4da',
              boxShadow: 'none',
            }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isSelected ? '#0e93c2' : state.isFocused ? '#e9ecef' : 'white',
              color: state.isSelected ? 'white' : '#495057',
            }),
          }}
        />
      </div>
    </div>
  );
};

export default withTranslation()(PeriodFilter);
